package es.subastia.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.js
import kotlinx.coroutines.launch
import kotlinx.coroutines.await
import kotlin.js.Promise

@Composable
actual fun rememberGoogleSignInLauncher(
    onResult: (Result<String>) -> Unit
): GoogleSignInLauncher {
    val coroutineScope = rememberCoroutineScope()
    
    return remember(onResult, coroutineScope) {
        object : GoogleSignInLauncher {
            override fun launch() {
                coroutineScope.launch {
                    try {
                        // Obtenemos el objeto Auth de Firebase JS
                        val nativeAuth = Firebase.auth.js
                        
                        // Obtenemos el constructor de GoogleAuthProvider directamente del módulo
                        // Esto evita errores de 'not a constructor' al cargar el módulo manualmente
                        val provider = js("new (require('firebase/auth').GoogleAuthProvider)()")
                        
                        // Llamamos a signInWithPopup del SDK de Firebase JS
                        // Usamos require para asegurar que llamamos a la función correcta del módulo
                        val signInWithPopup = js("require('firebase/auth').signInWithPopup")
                        val resultPromise = signInWithPopup(nativeAuth, provider) as Promise<dynamic>
                        val result = resultPromise.await()
                        
                        // Obtenemos el ID Token de Google desde el credential del resultado
                        // result.credential contiene el idToken original de Google
                        val googleIdToken = result.credential?.idToken as? String
                        
                        if (googleIdToken != null) {
                            onResult(Result.success(googleIdToken))
                        } else {
                            // Fallback: Si por alguna razón no está en credential, 
                            // intentamos obtenerlo del usuario (aunque esto es lo que daba 400 antes)
                            // A veces en Web, si ya está logueado, basta con devolver un éxito vacío 
                            // si el Auth ya lo detecta, pero para el flow compartido necesitamos el token.
                            val idTokenPromise = result.user.getIdToken(false) as Promise<String>
                            val idToken = idTokenPromise.await()
                            onResult(Result.success(idToken))
                        }
                    } catch (e: Exception) {
                        onResult(Result.failure(e))
                    }
                }
            }
        }
    }
}
